/* eslint-disable no-console */
import React from 'react';
import useDidMountEffect from './UseDidMountEffect';

interface UseInfiniteScrollProps {
	lastEleRef: React.RefObject<HTMLElement>;
	loaderRef: React.MutableRefObject<boolean>;
	count: number;
	data: object[];
	setPage: (prevPage) => void;
}

export const useScroll = ({
	lastEleRef,
	loaderRef,
	count,
	data,
	setPage
}: UseInfiniteScrollProps) =>
{
	useDidMountEffect(() =>
	{
		const observer = new IntersectionObserver(
			(entries) =>
			{
				if (entries[0]?.isIntersecting)
				{
					// console.log('page intersecting using intersection observer******');

					// Add more robust checks to prevent infinite loops
					if (!loaderRef?.current && count > data?.length && data?.length > 0)
					{
						loaderRef.current = true;
						setPage((prev) => prev + 1);
					}
				}
			},
			{
				root       : null,
				rootMargin : '0px',
				threshold  : 0.1
			}
		);

		if (lastEleRef.current)
		{
			// console.log('observation started******');

			observer.observe(lastEleRef.current);
		}

		return () =>
		{
			if (lastEleRef.current)
			{
				// console.log('observation ended******');

				observer.unobserve(lastEleRef.current);
			}
		};
	}, [ lastEleRef.current, data.length, count ]);
};
